export default __webpack_public_path__ + "1c3f71f16fb36ef38a030bf9df721c10.woff";